<template>
  <div class="register-account">
    <p class="step">
      ステップ<span>{{currentStep}}/{{numberOfSteps}}</span>
    </p>

    <p class="title">
      アカウント本登録
    </p>

    <Form v-slot="{meta, errors}" @submit="() => {}">
      <Input
        name="nickname"
        v-model="nickname"
        type="text"
        placeholder="お名前"
        as="input"
        rules="required"
        label="お名前"
        :display-error="!meta.valid && meta.touched && errors['nickname'] !== undefined"
        error-message="お名前を入力してください"
      />

      <Input
        name="phoneNumber"
        v-model="phoneNumber"
        type="text"
        placeholder="電話番号を入力してください"
        as="input"
        rules="required|phoneNumber"
        label="電話番号"
        :display-error="!meta.valid && meta.touched && errors['phoneNumber'] !== undefined"
        error-message="電話番号を正しく入力してください"
      />

      <Input
        name="password"
        v-model="password"
        type="password"
        placeholder="パスワードを入力してください"
        as="input"
        rules="required|min:8"
        label="パスワード"
        sublabel="8文字以上で設定してください。"
        :display-error="!meta.valid && meta.touched && errors['password'] !== undefined"
        error-message="パスワードを正しく入力してください"
      />

      <Input
        name="passwordConfirmation"
        v-model="passwordConfirmation"
        type="password"
        placeholder="同じパスワードをもう1度入力してください"
        as="input"
        rules="required|confirmed:@password"
        label="パスワード確認"
        :display-error="!meta.valid && meta.touched && errors['passwordConfirmation'] !== undefined"
        error-message="同じパスワードをもう1度入力してください"
      />

      <Input
        name="couponCode"
        v-model="couponCode"
        type="text"
        placeholder="キャンペーンコード"
        as="input"
        label="キャンペーンコード"
        :dontShowRequired="true"
        :no-vee-validate="true"
      />

      <div class="container">
        <Button @click="submit(meta.valid)" :class="{ invalid: !meta.valid }">
          次のステップへ
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import Button from '@/components/signup/Button.vue'
import Input from '@/components/signup/Input.vue'

export default {
  name: 'StepA_NamePassword',

  components: {
    Form,
    Button,
    Input
  },

  props: {
    currentStep: {
      type: Number,
      required: true
    },

    numberOfSteps: {
      type: Number,
      required: true
    },

    isCampaignTrial: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      nickname: '',
      password: '',
      passwordConfirmation: '',
      phoneNumber: '',
      couponCode: ''
    };
  },

  created() {
    if (!this.isCampaignTrial) {
      this.couponCode = ''
    }
  },

  methods: {
    submit(valid) {
      if (valid) {
        this.$emit('submit', {
          nickname: this.nickname,
          password: this.password,
          phoneNumber: this.phoneNumber,
          couponCode: this.couponCode
        })
      }
    }
  }
}
</script>

<style scoped>
.register-account p.step {
  font-size: 14px;
  line-height: 21px;
  color: black;
  margin-bottom: 10px;
}

.register-account p.step > span {
  font-weight: 600;
  margin-left: 10px;
}

.register-account p.title {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  color: black;
  margin-bottom: 20px;
}

.register-account p.label {
  font-size: 14px;
  line-height: 21px;
  color: black;
  margin-bottom: 10px;
}

.register-account form > .name {
  display: flex;
  margin-bottom: 20px;
}

.register-account form > .name + .input {
  margin-top: 18px;
}

.register-account form > .input + .input {
  margin-top: 10px;
}

.register-account form > div > .input + .input {
  margin-left: 10px;
}

.register-account .container {
  width: 335px;
  margin: 40px auto 0;
}

.register-account button {
  margin: 0 auto;
}

@media (max-width: 374px) {
  .register-account .container {
    width: calc(100vw - 40px);
    margin: 40px auto 0;
  }
}

</style>
